var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import ProgressBar from "./ProgressBar";
import ArrayUtils from "./util/array";
import ObjectUtils from "./util/object";
import LabeledPlay from "./LabeledPlay";
import classNames from "classnames";
import { cardLookup } from "./util/cardHelpers";
import { useEngine } from "./useEngine";
import { SettingsContext } from "./AppStateProvider";
import { explainScoringCache, getExplainScoringKey } from "./util/cachePrefill";
export var calculatePoints = function (players, landlordTeam, points, penalties) {
    var pointsPerPlayer = ObjectUtils.mapValues(points, function (cards) {
        return ArrayUtils.sum(cards.map(function (card) { return cardLookup[card].points; }));
    });
    var totalPointsPlayed = ArrayUtils.sum(Object.values(pointsPerPlayer));
    var nonLandlordPoints = ArrayUtils.sum(players
        .filter(function (p) { return !landlordTeam.includes(p.id); })
        .map(function (p) { return pointsPerPlayer[p.id]; }));
    var nonLandlordPointsWithPenalties = nonLandlordPoints;
    players.forEach(function (p) {
        var penalty = penalties[p.id];
        if (penalty > 0) {
            if (landlordTeam.includes(p.id)) {
                nonLandlordPointsWithPenalties += penalty;
            }
            else {
                nonLandlordPointsWithPenalties -= penalty;
            }
        }
    });
    return {
        nonLandlordPoints: nonLandlordPoints,
        nonLandlordPointsWithPenalties: nonLandlordPointsWithPenalties,
        totalPointsPlayed: totalPointsPlayed,
    };
};
var Points = function (props) {
    var pointsPerPlayer = ObjectUtils.mapValues(props.points, function (cards) {
        return ArrayUtils.sum(cards.map(function (card) { return cardLookup[card].points; }));
    });
    var settings = React.useContext(SettingsContext);
    var engine = useEngine();
    var _a = React.useState(null), scoreData = _a[0], setScoreData = _a[1];
    var _b = React.useState([]), scoreTransitions = _b[0], setScoreTransitions = _b[1];
    var _c = React.useState(100), totalPoints = _c[0], setTotalPoints = _c[1];
    var _d = React.useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = calculatePoints(props.players, props.landlordTeam, props.points, props.penalties), totalPointsPlayed = _e.totalPointsPlayed, nonLandlordPointsWithPenalties = _e.nonLandlordPointsWithPenalties, nonLandlordPoints = _e.nonLandlordPoints;
    var penaltyDelta = nonLandlordPointsWithPenalties - nonLandlordPoints;
    React.useEffect(function () {
        setIsLoading(true);
        // Load both computeScore and explainScoring in parallel
        var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var scoringKey, scoringResult, promises, results, scoreResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        scoringKey = getExplainScoringKey(props.gameScoringParameters, props.smallerTeamSize, props.decks);
                        scoringResult = explainScoringCache[scoringKey];
                        promises = [
                            engine.computeScore({
                                params: props.gameScoringParameters,
                                decks: props.decks,
                                smaller_landlord_team_size: props.smallerTeamSize,
                                non_landlord_points: nonLandlordPointsWithPenalties,
                            }),
                        ];
                        if (!scoringResult) {
                            promises.push(engine.explainScoring({
                                params: props.gameScoringParameters,
                                smaller_landlord_team_size: props.smallerTeamSize,
                                decks: props.decks,
                            }));
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        results = _a.sent();
                        scoreResult = results[0];
                        if (!scoringResult && results.length > 1) {
                            scoringResult = results[1];
                            explainScoringCache[scoringKey] = scoringResult;
                        }
                        setScoreData(scoreResult);
                        setScoreTransitions(scoringResult.results);
                        setTotalPoints(scoringResult.total_points);
                        setIsLoading(false);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error computing score:", error_1);
                        // Fallback to defaults
                        setScoreData({
                            score: {
                                landlord_won: false,
                                landlord_bonus: false,
                                landlord_delta: 0,
                                non_landlord_delta: 0,
                            },
                            next_threshold: 0,
                        });
                        setScoreTransitions([]);
                        setTotalPoints(100);
                        setIsLoading(false);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadData();
    }, [
        props.gameScoringParameters,
        props.decks,
        props.smallerTeamSize,
        nonLandlordPointsWithPenalties,
        engine,
    ]);
    if (isLoading || !scoreData) {
        return React.createElement("div", null, "Loading scores...");
    }
    var score = scoreData.score, nextThreshold = scoreData.next_threshold;
    var playerPointElements = props.players.map(function (player) {
        var onLandlordTeam = props.landlordTeam.includes(player.id);
        var cards = props.points[player.id].length > 0 ? props.points[player.id] : ["🂠"];
        var penalty = player.id in props.penalties ? props.penalties[player.id] : 0;
        if (props.hideLandlordPoints && onLandlordTeam) {
            return null;
        }
        else {
            return (React.createElement(LabeledPlay, { key: player.id, trump: props.trump, className: classNames({ landlord: onLandlordTeam }), label: "".concat(player.name, ": ").concat(pointsPerPlayer[player.id] - penalty, "\u5206"), cards: cards }));
        }
    });
    // TODO: Pass the landlord as a Player object instead of numeric ID
    var landlord = props.players.find(function (p) { return p.id === props.landlord; });
    var thresholdStr = "";
    if (score.landlord_won) {
        thresholdStr = "".concat(landlord === null || landlord === void 0 ? void 0 : landlord.name, "'s team will go up ").concat(score.landlord_delta, " level").concat(score.landlord_delta === 1 ? "" : "s");
        if (score.landlord_bonus) {
            thresholdStr += ", including a small-team bonus";
        }
    }
    else if (score.non_landlord_delta === 0) {
        thresholdStr = "Neither team will go up a level";
    }
    else {
        thresholdStr = "The attacking team will go up ".concat(score.non_landlord_delta, " level").concat(score.non_landlord_delta === 1 ? "" : "s");
    }
    thresholdStr += " (next threshold: ".concat(nextThreshold, "\u5206)");
    return (React.createElement("div", { className: "points" },
        React.createElement("h2", null, "Points"),
        !settings.showPointsAboveGame && (React.createElement(ProgressBar, { checkpoints: scoreTransitions
                .map(function (transition) { return transition.point_threshold; })
                .filter(function (threshold) { return threshold >= 10 && threshold < totalPoints; }), totalPoints: totalPoints, landlordPoints: totalPointsPlayed - nonLandlordPoints, challengerPoints: nonLandlordPointsWithPenalties, hideLandlordPoints: props.hideLandlordPoints })),
        React.createElement("p", null,
            penaltyDelta === 0
                ? nonLandlordPoints
                : "".concat(nonLandlordPoints, " + ").concat(penaltyDelta),
            "\u5206",
            props.hideLandlordPoints ? null : " / ".concat(totalPointsPlayed, "\u5206"),
            " stolen from ", landlord === null || landlord === void 0 ? void 0 :
            landlord.name,
            "'s team. ",
            thresholdStr),
        playerPointElements));
};
export var ProgressBarDisplay = function (props) {
    var engine = useEngine();
    var _a = React.useState([]), scoreTransitions = _a[0], setScoreTransitions = _a[1];
    var _b = React.useState(0), totalPoints = _b[0], setTotalPoints = _b[1];
    var _c = React.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = calculatePoints(props.players, props.landlordTeam, props.points, props.penalties), totalPointsPlayed = _d.totalPointsPlayed, nonLandlordPointsWithPenalties = _d.nonLandlordPointsWithPenalties, nonLandlordPoints = _d.nonLandlordPoints;
    React.useEffect(function () {
        setIsLoading(true);
        var loadScoring = function () { return __awaiter(void 0, void 0, void 0, function () {
            var scoringKey, result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        scoringKey = getExplainScoringKey(props.gameScoringParameters, props.smallerTeamSize, props.decks);
                        result = explainScoringCache[scoringKey];
                        if (!!result) return [3 /*break*/, 2];
                        return [4 /*yield*/, engine.explainScoring({
                                params: props.gameScoringParameters,
                                smaller_landlord_team_size: props.smallerTeamSize,
                                decks: props.decks,
                            })];
                    case 1:
                        result = _a.sent();
                        explainScoringCache[scoringKey] = result;
                        _a.label = 2;
                    case 2:
                        setScoreTransitions(result.results);
                        setTotalPoints(result.total_points);
                        setIsLoading(false);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Error explaining scoring:", error_2);
                        setScoreTransitions([]);
                        setTotalPoints(100); // Default total
                        setIsLoading(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadScoring();
    }, [props.gameScoringParameters, props.smallerTeamSize, props.decks, engine]);
    if (isLoading) {
        return React.createElement("div", null, "Loading progress bar...");
    }
    return (React.createElement(ProgressBar, { checkpoints: scoreTransitions
            .map(function (transition) { return transition.point_threshold; })
            .filter(function (threshold) { return threshold >= 10 && threshold < totalPoints; }), totalPoints: totalPoints, landlordPoints: totalPointsPlayed - nonLandlordPoints, challengerPoints: nonLandlordPointsWithPenalties, hideLandlordPoints: props.hideLandlordPoints }));
};
export default Points;
